import { render, staticRenderFns } from "./AppointmentJobDetailsPanel.vue?vue&type=template&id=edb5b51c&scoped=true"
import script from "./AppointmentJobDetailsPanel.vue?vue&type=script&lang=ts"
export * from "./AppointmentJobDetailsPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb5b51c",
  null
  
)

export default component.exports